import Component from '../core/Component';
export const STATUS = {
    ACTIVE: 'active'
}
export default class HomepageCarousel extends Component {

    constructor($element) {
        super($element);
        this.$items = $('.homepage-header__info-item');
        this.$dots = $('.homepage-header__dot'); 
        this.count = 0;
        this.loop = null;
    }

    prepare() {
        var self = this;
        this.createLoop();
        this.$dots.on('click', function(){
            var id = $( this ).index();
            if (id == self.count){
                return   
            }
            self.count = id;
            self.activate(id);
            self.createLoop();
            
        }); 
    }

    createLoop(){
        clearInterval(this.loop);
        this.loop = setInterval(()=>{
            this.count ++;
            if (this.count == this.$items.length){
                this.count = 0;
            }
            this.activate(this.count)
        }, 4000) 
    }

    activate(id){
        this.$items.removeClass('after');
        this.$element.find('.homepage-header__info-item.active').addClass('after');
        this.$items.removeClass(STATUS.ACTIVE);
        this.$items.eq(id).addClass(STATUS.ACTIVE);
        this.$dots.removeClass(STATUS.ACTIVE);
        this.$dots.eq(id).addClass(STATUS.ACTIVE); 
    }


}


// WEBPACK FOOTER //
// ./components/HomepageCarousel.js